import { createBrowserRouter, Navigate } from 'react-router';

import { AuthorizedLayout } from '@/layouts/authorized';
import { UnauthorizedLayout } from '@/layouts/unauthorized';
import {
    ADMINS_ROUTE,
    CUSTOMERS_ROUTE,
    DASHBOARD_ROUTE,
    LOGIN_ROUTE,
    NOT_FOUND_ROUTE,
    PATIENTS_ROUTE,
    PRACTICES_ROUTE,
} from '@/pages';
import { EAdminRoutes } from '@/services/router/enums';
import { ErrorComponent } from '@/ui/error';

export const ADMIN_ROUTER = createBrowserRouter([
    {
        element: <AuthorizedLayout />,
        errorElement: (
            <UnauthorizedLayout>
                <ErrorComponent errorCode={500} />
            </UnauthorizedLayout>
        ),
        children: [DASHBOARD_ROUTE, PATIENTS_ROUTE, PRACTICES_ROUTE, CUSTOMERS_ROUTE, ADMINS_ROUTE],
    },
    {
        element: <UnauthorizedLayout />,
        errorElement: (
            <UnauthorizedLayout>
                <ErrorComponent errorCode={500} />
            </UnauthorizedLayout>
        ),
        children: [LOGIN_ROUTE],
    },
    {
        element: <UnauthorizedLayout />,
        errorElement: (
            <UnauthorizedLayout>
                <ErrorComponent errorCode={500} />
            </UnauthorizedLayout>
        ),
        children: [NOT_FOUND_ROUTE],
    },
    {
        path: '/',
        element: <Navigate to={EAdminRoutes.Dashboard} replace />,
    },
    {
        path: '*',
        element: <Navigate to={EAdminRoutes.NotFoundException} replace />,
    },
]);
